import * as type from '../type';
import * as user from '../../api/user';

const state = {};

const actions = {
    login({
        state,
        commit
    }, payload) {
        return new Promise((resolve, reject) => {
            user.login(
                payload.email,
                payload.pwd,
            ).then(res => {
                if (res.data.res_code == 1) {
                    commit(type.LOGIN, res.data.msg);
                    resolve(res.data.msg);
                } else {
                    reject(res.data.msg);
                }
            }).catch(error => {
                console.error(error);
                reject();
            })
        })
    },
    logout({
        state,
        commit,
    }, payload) {
        commit(type.LOGOUT)
    },
    sendRegistMail({
        state,
        commit
    }, payload) {
        return new Promise((resolve, reject) => {
            user.sendRegistMail(
                payload.email
            ).then(res => {
                if (res.data.res_code == 1) {
                    resolve(res.data.msg);
                } else {
                    reject(res.data.msg)
                }
            }).catch(error => {
                console.error(error);
                reject();
            })
        })
    },
    regist({
        state,
        commit
    }, payload) {
        return new Promise((resolve, reject) => {
            user.regist(
                payload.guid,
                payload.employer_name,
                payload.employer_img_url,
                payload.name,
                payload.img_url,
                payload.pwd,
                payload.phone,
            ).then(res => {
                if (res.data.res_code == 1) {
                    resolve(res.data.msg);
                } else {
                    reject(res.data.msg);
                }
            }).catch(error => {
                console.error(error);
                reject();
            })
        })
    },
    getEmployer({
        state,
        commit
    }, payload) {
        return new Promise((resolve, reject) => {
            user.getEmployer(
                payload.guid
            ).then(res => {
                if (res.data.res_code == 1) {
                    resolve(res.data.msg);
                } else {
                    reject(res.data.msg);
                }
            }).catch(error => {
                console.error(error);
                reject();
            })
        })
    },
    getUserInfo({
        state,
        commit
    }, payload) {
        return new Promise((resolve, reject) => {
            user.getUserInfo(
                payload.guid
            ).then(res => {
                if (res.data.res_code == 1) {
                    resolve(res.data.msg);
                } else {
                    reject(res.data.msg);
                }
            }).catch(error => {
                console.error(error);
                reject();
            })
        })
    },
    bindEmployer({
        state,
        commit
    }, payload) {
        return new Promise((resolve, reject) => {
            user.bindEmployer(
                payload.guid,
                payload.name,
                payload.img_url,
                payload.pwd,
                payload.phone
            ).then(res => {
                if (res.data.res_code == 1) {
                    resolve(res.data.msg);
                } else {
                    reject(res.data.msg);
                }
            }).catch(error => {
                console.error(error);
                reject();
            })
        })
    },
    getEmployerList({
        state,
        commit
    }, payload) {
        return new Promise((resolve, reject) => {
            user.getEmployerList().then(res => {
                if (res.data.res_code == 1) {
                    resolve(res.data.msg);
                } else {
                    reject(res.data.msg)
                }
            }).catch(error => {
                console.error(error);
                reject(error);
            })
        })
    }
};

const mutations = {
    [type.LOGIN]: (state, payload) => {
        localStorage.setItem('employer_id', payload.employer_id);
        localStorage.setItem('employer_name', payload.employer_name);
        localStorage.setItem('user_name', payload.user_name);
        localStorage.setItem('user_id', payload.to_user_id);
        localStorage.setItem('img_url', payload.img_url);
        localStorage.removeItem("code");
        localStorage.setItem("token", payload.token);
    },
    [type.LOGOUT]: (state, payload) => {
        localStorage.removeItem('employer_id');
        localStorage.removeItem('employer_name');
        localStorage.removeItem('user_name');
        localStorage.removeItem('user_id');
        localStorage.removeItem('img_url');
        localStorage.removeItem('token');
    },
};

export default {
    state,
    actions,
    mutations
}